/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';

import announcementsPage from '../views/announcementsPage/announcementsPage';
import calendarPage from '../views/calendarPage/calendarPage';
import nutritionAllergenPage from '../views/nutritionAllergenPage/nutritionAllergenPage';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/:districtSlug/calendar',
        },
        {
            path: '/:districtSlug',
            redirect: '/:districtSlug/calendar',
        },
        {
            path: '/:districtSlug/nutrition-allergen',
            name: 'nutrition-allergen',
            component: nutritionAllergenPage,
        },
        {
            path: '/:districtSlug/calendar',
            name: 'calendar',
            component: calendarPage,
        },
        {
            path: '/:districtSlug/announcements',
            name: 'announcements',
            component: announcementsPage,
        },
    ],
});

export default router;
